<h1>Opt Out Emails</h1>
<fgbcl-errors></fgbcl-errors>
<div *ngIf="optOutEmails$ | async; else failed">
  <div *ngFor="let optOutEmail of optOutEmails">
    <input
      class="form-check-input"
      type="checkbox"
      (change)="optOutEmail.Status = $event.target.checked ? 1 : 0"
      [checked]="optOutEmail.Status === 1"
      [(ngModel)]="optOutEmail.Status"
      [id]="optOutEmail.EmailTypeId"
      required
    />
    <label class="form-check-label font-weight-normal" [for]="optOutEmail.EmailTypeId">
      {{ optOutEmail.Description }}
    </label>
  </div>
</div>
<fgb-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgb-registration-navigation>
<ng-template #failed> </ng-template>
